// Define Your App Constants
const _toastVariants = {
    Warn: 'warn',
    Error: 'error',
    Success: 'success'
};

const _status = {
    active: "Active",
    inactive: "Inactive"
}

const _UserType = {
    1: 'Admin',
}

export {
    _toastVariants,
    _status,
    _UserType
}